import PropTypes from 'prop-types';
import React from 'react';
import { VelocityTransitionGroup } from 'velocity-react';
import styles from './ScreenInfo.module.css';
var enterAnimation = {
    animation: {
        opacity: 1,
    },
    duration: 300,
};
var leaveAnimation = {
    animation: {
        opacity: 0,
    },
    duration: 300,
};
export default function ScreenInfo(_a) {
    var screenName = _a.screenName, screenNumber = _a.screenNumber, screenCount = _a.screenCount, isVisible = _a.isVisible;
    return (React.createElement(VelocityTransitionGroup, { enter: enterAnimation, leave: leaveAnimation }, isVisible && (React.createElement("div", { className: styles.screenInfo },
        screenNumber,
        " / ",
        screenCount,
        " \u2014 ",
        screenName))));
}
ScreenInfo.propTypes = {
    screenName: PropTypes.string,
    screenNumber: PropTypes.number,
    screenCount: PropTypes.number,
    isVisible: PropTypes.bool.isRequired,
};
